import { Button, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import { AccountCircle } from '@components/icons'
import React from 'react'

export const WaitingRoomPopover = ({
  openParticipantsPanel,
  onAdmit,
  onClose,
  participant,
  hasFiveMinutesPassed,
  style = {}
}: {
  openParticipantsPanel: () => void
  participant: any
  hasFiveMinutesPassed: boolean
  style?: { bottom?: string }
  onAdmit: () => void
  onClose: () => void
}) => {
  const bottom = style?.bottom || '92px'

  return (
    <Flex
      position="absolute"
      direction="column"
      bottom={bottom}
      right="32px"
      bg="primary"
      borderRadius="16px"
      p="small"
      w="250px"
      minH="130px"
      boxShadow="0px 0px 10px 0px rgba(0, 0, 0, 0.1)"
      zIndex="10"
    >
      <Text mt={0} color="white" fontSize="14px" fontWeight="bold">
        Someone's in the waiting room
      </Text>
      <VStack mt="small" spacing="xsmall">
        <HStack
          borderRadius="8px"
          w="100%"
          bg="#4265EA"
          p="xsmall"
          gap="0"
          alignItems="center"
        >
          <AccountCircle fill="white" />
          <Text color="white" fontSize="14px">
            {participant.name}
          </Text>
        </HStack>
        <Flex alignSelf="flex-end" justify="flex-end" align="center">
          {hasFiveMinutesPassed ? (
            <Button
              color="white"
              borderRadius="8px"
              variant="ghost"
              borderColor="#4265EA"
              size="sm"
              _focus={{ outline: 'none' }}
              onClick={onClose}
              data-click-text="Dismiss"
            >
              Dismiss
            </Button>
          ) : (
            <Button
              color="primary"
              bg="white"
              borderRadius="8px"
              size="sm"
              onClick={onAdmit}
              data-click-text="Admit"
            >
              Admit
            </Button>
          )}
          <Button
            color="white"
            borderRadius="8px"
            variant="outline"
            borderColor="#4265EA"
            size="sm"
            _focus={{ outline: 'none' }}
            onClick={openParticipantsPanel}
            data-click-text="View"
          >
            View
          </Button>
        </Flex>
      </VStack>
    </Flex>
  )
}
